export default __webpack_public_path__ + "static/media/fernando.9a3974e8.jpg";